import { Close as CloseIcon, Save as SaveIcon } from '@mui/icons-material'
import { IconButton, Stack } from '@mui/material'
import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'

import { FlexBox } from 'components/Box'
import { Select, SelectAutocomplete } from 'components/Form'
import { SelectOption } from 'components/Select'
import { userWorkspaceRoleOptions } from 'features/user'
import { WorkspaceSlice } from '../hooks/useGetWorkspaceOptions'
import { UserWorkspaceForForm } from '../types'
import { NextFormContext } from './contexts/NextFormContext'
import { UserWorkspacesContext } from './contexts/UserWorkspacesContext'
import { CommonSchema } from './schemas'

type Props = {
  workspaceOptions: SelectOption<WorkspaceSlice>[]
}

export const AddForm = ({ workspaceOptions }: Props): JSX.Element => {
  const { control, reset } = useFormContext<CommonSchema>()
  const { userWorkspaces } = useContext(UserWorkspacesContext)
  const { setShowNextInputs } = useContext(NextFormContext)

  return (
    <Stack
      direction='row'
      sx={{ gap: 2 }}
    >
      <SelectAutocomplete<CommonSchema, WorkspaceSlice>
        control={control}
        disabledOptions={userWorkspaces.map(({ workspaceId }: UserWorkspaceForForm) => workspaceId)}
        name='workspaceId'
        options={workspaceOptions}
      />

      <Select
        control={control}
        name='role'
        options={userWorkspaceRoleOptions()}
      />

      <FlexBox axis='x'>
        <>
          <IconButton type='submit'>
            <SaveIcon data-cy='save-icon' />
          </IconButton>

          <IconButton
            onClick={(): void => {
              reset()
              setShowNextInputs(false)
            }}
          >
            <CloseIcon data-cy='close-icon' />
          </IconButton>
        </>
      </FlexBox>
    </Stack>
  )
}
